import React, { useState } from "react";
import error from "../assets/images/error.svg";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";
import ResultSection from "../components/ResultSection";

import nominalDiameter from "../assets/data/nominal_diameter.json";
import vaccum from "../assets/data/vaccum.json";
import material from "../assets/data/material.json";
import properties from "../assets/data/properties.json";
import mediaGroup from "../assets/data/media_group.json";
import compositeChemical from "../assets/data/composite_chemical.json";
import fumesChemical from "../assets/data/fumes_chemical.json";
import mainChemical from "../assets/data/main_checmical.json";
import hoseData from "../assets/data/hose_data_rev1.json";

function Dashboard(props) {
  const CONCENTARTED_CHEMICAL_LOWER = "concentrated chemical";
  const FUMES_LOWER = "fumes";
  const CONCENTARTED_CHEMICAL = "CONCENTRATED CHEMICAL";
  const FUMES = "Fumes";

  const [showInput, setShowInput] = useState(false);
  const [errors, setErrors] = useState({});
  const [chemicalArray, setChemicalArray] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [fmsChemical, setFmsChemical] = useState([]);
  const [results, setResults] = useState({
    resultingHose: [],
    suitability: [],
  });

  const compositeChemicalArray = compositeChemical.map((obj) => JSON.stringify(obj.Chemical).replace(new RegExp('"', "g"), ""));

  const fumesChemicalArray = fumesChemical.map((obj) => JSON.stringify(obj.Chemical).replace(new RegExp('"', "g"), ""));

  const mainChemicalArray = mainChemical.map((obj) => JSON.stringify(obj.Chemical).replace(new RegExp('"', "g"), ""));

  const [formData, setFormData] = useState({
    Nominal: "",
    Temp: "",
    Pressure: "",
    Vacuum: vaccum[0],
    Material: material[0],
    properties: [],
    Media: "",
    Chemical: "",
  });

  const handleKeyPress = (e) => {
    // Allow only numeric digits (0-9)
    const isValidKey = /^\d*\.?\d*$/.test(e.key);

    // If the pressed key is not a numeric digit, prevent the input
    if (!isValidKey) {
      e.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDropdownChange = (selectedOption, fieldName) => {
    if (fieldName === "Material") {
      setFormData({
        ...formData,
        [fieldName]: selectedOption,
        Media: "",
        Chemical: "",
      });
    } else if (fieldName === "Media") {
      setFormData({
        ...formData,
        [fieldName]: selectedOption,
        Chemical: "",
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: selectedOption,
      });
    }
    setShowInput((selectedOption && selectedOption.value === CONCENTARTED_CHEMICAL) || selectedOption.value === FUMES);
    setSuggestionArray(selectedOption.value);
  };

  const handleMultiDropdownChange = (updatedList, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: updatedList,
    });
  };

  const validateForm = () => {
    var isvalid = true;
    const newErrors = {
      Nominal: "",
      Temp: "",
      Pressure: "",
      Vacuum: "",
      Chemical: "",
    };
    if (!formData.Nominal) {
      isvalid = false;
      newErrors.Nominal = "Nominal diameter is required";
    }
    if (!formData.Temp) {
      isvalid = false;
      newErrors.Temp = "Temperature is required";
    }
    if (!formData.Pressure) {
      isvalid = false;
      newErrors.Pressure = "Pressure is required";
    }
    if (!formData.Vacuum) {
      isvalid = false;
      newErrors.Vacuum = "Vacuum is required";
    }
    if (
      !formData.Chemical &&
      formData.Media &&
      (formData.Media.value.toLowerCase() === FUMES_LOWER || formData.Media.value.toLowerCase() === CONCENTARTED_CHEMICAL_LOWER)
    ) {
      isvalid = false;
      newErrors.Chemical = "Chemical is required";
    }

    setErrors(newErrors);
    return isvalid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Validation passed", formData);

      const filteredHoses = hoseData.filter((hose) => {
        if (formData.Vacuum.label === "No Vacuum") {
          return (
            hose.nominal_diameter.toString() === formData.Nominal.label.toString() &&
            Number(hose.temperature) >= formData.Temp &&
            Number(hose.pressure) >= formData.Pressure &&
            (formData.Material.label === "No Preference" || hose.user_material === formData.Material.label)
          );
        } else {
          return (
            hose.nominal_diameter.toString() === formData.Nominal.label.toString() &&
            Number(hose.temperature) >= formData.Temp &&
            Number(hose.pressure) >= formData.Pressure &&
            (Number(hose.vacuum) >= formData.Vacuum.label || hose.vacuum.toLowerCase() === "full") &&
            (formData.Material.label === "No Preference" || hose.user_material === formData.Material.label)
          );
        }
      });

      const filteredHosesForProperties = findHosesWithProperties(filteredHoses, formData.properties);

      const filteredHosesWithChemical = filteredHosesForProperties.filter((hose) => {
        if (formData.Media.label === undefined) {
          return hose;
        } else {
          return hose[formData.Media.value.toLowerCase().replace(new RegExp(" ", "g"), "_")] === "x";
        }
      });

      const resultingHose =
        formData.Media.label !== undefined &&
        (formData.Media.label.toLowerCase().replace(new RegExp(" ", "g"), "_") === "fumes" ||
          formData.Media.label.toLowerCase().replace(new RegExp(" ", "g"), "_") === "concentrated_chemical")
          ? filteredHosesWithChemical.filter((hose) =>
              fmsChemical.some((property) => {
                return (
                  property.Chemical === formData.Chemical &&
                  (property[hose.chemical_material] === "A" || property[hose.chemical_material] === "B")
                );
              })
            )
          : filteredHosesWithChemical;

      const filteredChecmical = fmsChemical.filter((property) => {
        return property.Chemical === formData.Chemical;
      });
      const sortedResultingHoses =
        filteredChecmical.length === 0
          ? resultingHose
          : resultingHose.sort((hoseA, hoseB) => {
              return filteredChecmical[0][hoseB.chemical_material] > filteredChecmical[0][hoseA.chemical_material] ? -1 : 1;
            });

      const materialSuitability = fmsChemical.filter((checmicalObject) => {
        return checmicalObject.Chemical === formData.Chemical;
      });

      setResults({
        ...results,
        suitability: materialSuitability,
        resultingHose: sortedResultingHoses.slice(0, 10), // limiting resulting data to max 10
      });
    } else {
      console.log("Validation failed", formData);
    }
  };

  const setSuggestionArray = (selectedMedia) => {
    if (selectedMedia === CONCENTARTED_CHEMICAL || selectedMedia === FUMES) {
      setChemicalArray([]);
      setSuggestions([]);

      if (formData.Material.value && formData.Material.value.toLowerCase() === "composite") {
        setChemicalArray(compositeChemicalArray);
        setFmsChemical(compositeChemical);
      } else {
        if (selectedMedia.toLowerCase() === "fumes") {
          setChemicalArray(fumesChemicalArray);
          setFmsChemical(fumesChemical);
        } else {
          setChemicalArray(mainChemicalArray);
          setFmsChemical(mainChemical);
        }
      }
    }
  };

  const handleChemicalInputChange = (event) => {
    const value = event.target.value;
    setFormData({
      ...formData,
      Chemical: value,
    });
    const matchedSuggestions = chemicalArray.filter((item) => item.toLowerCase().includes(value.toLowerCase()));

    setSuggestions(matchedSuggestions);
  };
  const handleSuggestionClick = (suggestion) => {
    setFormData({
      ...formData,
      Chemical: suggestion,
    });
    setSuggestions([]);
  };

  function findHosesWithProperties(hoseList, selectedProperty) {
    return hoseList.filter((hose) => {
      return selectedProperty.every((property) => hose[property.cat] === "x");
    });
  }

  return (
    <>
      <main id="main">
        <div className="containerp">
          <p className="mb-0">Fill in the S.T.A.M.P. application Inputs below, then click LIST RANKED HOSES for the Output hose list.</p>
        </div>

        <section className="why-us section-bg">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5 d-flex flex-column  align-items-stretch  order-1 order-lg-2">
                <p>S.T.A.M.P. Input</p>

                <form onSubmit={handleSubmit} className="form">
                  <div className="column">
                    <div className="input-box1">
                      <p className="lable-input">Size</p>
                      <label>Nominal Diameter (in)</label>
                      <div
                        className="custom-select"
                        style={{
                          border: errors.Nominal && errors ? "1px solid red" : "1px solid #949AA5",
                          borderRadius: "5px",
                        }}>
                        <Select
                          value={formData.Nominal}
                          onChange={(selectedOption) => handleDropdownChange(selectedOption, "Nominal")}
                          options={nominalDiameter}
                        />
                      </div>
                      {errors.Nominal && (
                        <p className="error">
                          <img src={error} alt="" /> &nbsp;{errors.Nominal}
                        </p>
                      )}
                    </div>
                    <div className="input-box ">
                      <div className="lable-input">Temperature</div>
                      <label>Max Media (°F)</label>
                      <input
                        type="text"
                        placeholder=""
                        name="Temp"
                        value={formData.Temp}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        style={{
                          border: errors.Temp && errors ? "1px solid red" : "1px solid #949AA5",
                        }}
                      />
                      {errors.Temp && (
                        <p className="error">
                          <img src={error} alt="" /> &nbsp;{errors.Temp}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="column">
                    <div className="input-box">
                      <div className="lable-input">Pressure</div>
                      <label>Positive (psi)</label>
                      <input
                        type="text"
                        placeholder=""
                        name="Pressure"
                        value={formData.Pressure}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        style={{
                          border: errors.Pressure && errors ? "1px solid red" : "1px solid #949AA5",
                        }}
                      />
                      {errors.Pressure && (
                        <p className="error">
                          <img src={error} alt="" /> &nbsp;{errors.Pressure}
                        </p>
                      )}
                    </div>
                    <div className="input-box1">
                      <p className="lable-input"></p>
                      <label>Vacuum (in HG)</label>
                      <div
                        className="custom-select"
                        style={{
                          border: errors.Vacuum && errors ? "1px solid red" : "1px solid #949AA5",
                          borderRadius: "5px",
                        }}>
                        <Select
                          value={formData.Vacuum}
                          onChange={(selectedOption) => handleDropdownChange(selectedOption, "Vacuum")}
                          options={vaccum}
                        />
                      </div>
                      {errors.Vacuum && (
                        <p className="error">
                          <img src={error} alt="" /> &nbsp;{errors.Vacuum}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="column">
                    <div className="input-box1">
                      <p className="lable-input">Application</p>
                      <label>Preferred Material</label>
                      <p>(If any)</p>
                      <div className="custom-select">
                        <Select
                          value={formData.Material}
                          onChange={(selectedOption) => handleDropdownChange(selectedOption, "Material")}
                          options={material}
                        />
                      </div>
                    </div>
                    <div className="input-box1">
                      <p className="lable-input"></p>
                      <label>Properties</label>
                      <p>(Choose all that apply)</p>
                      <div className="custom-select">
                        <Multiselect
                          displayValue="key"
                          onKeyPressFn={function noRefCheck() {}}
                          onSearch={function noRefCheck() {}}
                          value={formData.properties}
                          onSelect={(selectedList, selectedItem) => handleMultiDropdownChange(selectedList, "properties")}
                          onRemove={(selectedList, selectedItem) => handleMultiDropdownChange(selectedList, "properties")}
                          options={properties}
                          showCheckbox
                          placeholder="Select if Any"
                          hidePlaceholder
                        />
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <div className="input-box1">
                      <p className="lable-input">Media</p>
                      <label>Media Group</label>
                      <p>*If CONCETRATED CHEMICAL or Fumes is selected, a new box will open to input part of the chemical name.</p>
                      <div className="custom-select">
                        <Select
                          value={formData.Media}
                          onChange={(selectedOption) => handleDropdownChange(selectedOption, "Media")}
                          options={mediaGroup}
                        />
                      </div>
                    </div>
                  </div>
                  {showInput && (
                    <div className="column">
                      <div className="input-box">
                        <label>Chemical</label>
                        <input
                          type="text"
                          placeholder="Type any part of chemical name to select from list."
                          name="Chemical"
                          value={formData.Chemical}
                          onChange={handleChemicalInputChange}
                          style={{
                            border: errors.Chemical && errors ? "1px solid red" : "1px solid #949AA5",
                          }}
                        />
                        {errors.Chemical && (
                          <p className="error">
                            {" "}
                            <img src={error} alt="" /> &nbsp;{errors.Chemical}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((suggestion, index) => (
                        <li key={index} onClick={() => handleSuggestionClick(suggestion)} className="dropdown-content">
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                  <div className="submit">
                    <button>LIST RANKED HOSES</button>
                  </div>
                </form>
              </div>
              <ResultSection items={results} />
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Dashboard;
